exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-dropdown[data-v-5bf6d14a] {\n    width: 130px;\n    height: 32px;\n    padding-left: 12px;\n    padding-top: 6px;\n    background: #FFFFFF 0 0 no-repeat padding-box;\n    box-shadow: 0 2px 3px #0000000D;\n    border: 1px solid #D7DAE2;\n    border-radius: 4px;\n    opacity: 1;\n    color: #4D4F5C;\n    font: Normal 13px/20px Source Sans Pro;\n    text-decoration: none;\n    display: flex;\n    justify-content: space-between;\n}\n.dropdown-item[data-v-5bf6d14a] {\n    cursor: pointer;\n}\n.fa-angle-down[data-v-5bf6d14a] {\n    color: #A4AFB7;\n    line-height: 1.7;\n    margin-right: 8px;\n}\n", ""]);

// exports
